import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from "../../../services/auth.service";
import { EventService } from "../../../services/event.service";
import { NotificationService } from "../../../services/notification.service";
import { NavigationHelper } from "../../../helpers/navigation.helper";
import { Subscription } from "rxjs/Subscription";


@Component({
  selector: 'header-bar',
  templateUrl: 'header-bar.html'
})
export class HeaderBar implements OnInit, OnDestroy {

  private onNotificationUpdateSubscription: Subscription;

	notificationsActive: boolean = false;
	dropdownItemClicked: boolean = false;


	constructor(public authService: AuthService,
              public notificationService: NotificationService,
              private changeDetector: ChangeDetectorRef,
              public eventService: EventService) {
    
    
  }


  ngOnInit(): void {
    this.onNotificationUpdateSubscription = this.notificationService.onUnreadChanged.subscribe(()=>{
      this.changeDetector.detectChanges();
    });

		this.eventService.componentActivated.subscribe((newComponent) => {
			this.notificationsActive = (newComponent === 'NotificationsPage');
		});

		this.eventService.notificationDropdownItemClicked.subscribe(() => {
			this.dropdownItemClicked = true;
			setTimeout(()=> {
				this.dropdownItemClicked = false;
			},200);
		});
  }

  ngOnDestroy(): void {
    if(this.onNotificationUpdateSubscription) this.onNotificationUpdateSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/partials/header/header-bar/header-bar.ts